var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import AmountItemWrapper from "./AmountItemWrapper";
/**
 * LineItemWrapper
 *  Encapsulates a LineItem data object with a LineItemConfig configuration object. Provides functionalities such as amount item wrapper generation and explanation rule checking.
 **/
var LineItemWrapper = /** @class */ (function () {
    /**
     * Create a new LineItem wrapper.
     * @param item Item to wrap.
     * @param config Configuration settings.
     */
    function LineItemWrapper(item, config) {
        if (!item) {
            throw new Error("Failed to initialize LineItemWrapper: item must be provided.");
        }
        this._lineItem = item;
        this._config = config;
    }
    /**
     * Checks if the line item requires an explanation.
     * */
    LineItemWrapper.prototype.requireExplanation = function () {
        if (this._config.rules && this._config.rules.length > 0) {
            return this._config
                .rules
                .some(function (rule) { return rule(); });
        }
        return false;
    };
    LineItemWrapper.prototype.explainWhen = function (rule) {
        var currentItem = this;
        this._config.rules.push(function () { return rule(currentItem); });
    };
    LineItemWrapper.prototype.cell = function (amountType) {
        var selector = function (amountItem) { return amountItem.type == amountType; };
        var items = this._lineItem.amountItems.filter(selector);
        if (items.length != 1) {
            throw new Error("Amount item selector matches multiple items!");
        }
        else {
            var item = items[0];
            var config = this._config.getOrCreateAmountItemConfig(item.columnKey);
            return new AmountItemWrapper(item, config);
        }
    };
    LineItemWrapper.prototype.amountFor = function (amountType) {
        return this.cell(amountType).amount;
    };
    Object.defineProperty(LineItemWrapper.prototype, "amountItems", {
        get: function () {
            var e_1, _a;
            var items = [];
            try {
                for (var _b = __values(this._lineItem.amountItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var amountItem = _c.value;
                    var config = this._config.getAmountItemConfigOrDefault(amountItem.columnKey);
                    items.push(new AmountItemWrapper(amountItem, config));
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return items;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LineItemWrapper.prototype, "key", {
        get: function () {
            return this._lineItem.key;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LineItemWrapper.prototype, "type", {
        get: function () {
            return this._lineItem.type;
        },
        set: function (value) {
            this._lineItem.type = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LineItemWrapper.prototype, "isLocalized", {
        get: function () {
            return this._lineItem.isLocalized;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LineItemWrapper.prototype, "name", {
        get: function () {
            return this._lineItem.name;
        },
        set: function (modifiedValue) {
            this._lineItem.name = modifiedValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LineItemWrapper.prototype, "description", {
        get: function () {
            return this._lineItem.description;
        },
        set: function (modifiedValue) {
            this._lineItem.description = modifiedValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LineItemWrapper.prototype, "isReadOnly", {
        get: function () {
            return this._lineItem.isReadOnly;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LineItemWrapper.prototype, "canDelete", {
        get: function () {
            return this._lineItem.canDelete;
        },
        enumerable: false,
        configurable: true
    });
    return LineItemWrapper;
}());
export default LineItemWrapper;
